// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 300px;
  height: 100%;
}

.Sidebars {
  display: flex;
  height: 100%;
  width: 50px;
  background-color: #3c4b64;
  position: fixed !important;
  z-index: 1;
  overflow: auto;
  padding-top: 25px;
}

.Sidebars .row {
  width: 100%;
  display: block;
  /* padding-top: 40px; */
  text-align: center;
  border: none;
  white-space: normal;
  float: none;
  outline: 0;
}

.Sidebars .row svg {
  color: white;
  height: 100%;
  width: 30px;
}

.Sidebars .notification svg {
  color: white;
  height: 100%;
  width: 18px;
}

.Sidebars .notification {
  width: 100%;
  display: block;
  /* padding-top: 50px; */
  text-align: center;
  border: none;
  white-space: normal;
  float: none;
  outline: 0;
}

.completeRows {
  display: flex;
  flex-direction: column;
  gap: 35px;
  align-items: center;
}

.Sidebars .lowrow {
  cursor: pointer;
  padding: 13px;
}

.Sidebars .lowrow:hover {
  background-color: crimson;
}

.Sidebars .lowrow svg {
  color: white;
  height: 100%;
  width: 22px;
}

.circularBg {
  background-color: #1976d2;
  height: 45px;
  width: 50px;
  padding-left: 0px;
  margin-left: 0px;
}

.notificationBg {
  background-color: #1976d2;
  height: 45px;
  width: 50px;
  padding-left: 0px;
  margin-left: 0px;
}

.includingLogout {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 40px;
}`, "",{"version":3,"sources":["webpack://./components/Sidebar/sidebars.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,0BAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AACF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAEF;;AAAA;EACE,eAAA;EACA,aAAA;AAGF;;AADA;EACE,yBAAA;AAIF;;AAFA;EACE,YAAA;EACA,YAAA;EACA,WAAA;AAKF;;AAFA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAKF;;AAFA;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAKF;;AAHA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;AAMF","sourcesContent":[".sidebar {\n  width: 300px;\n  height: 100%;\n}\n\n.Sidebars {\n  display: flex;\n  height: 100%;\n  width: 50px;\n  background-color: #3c4b64;\n  position: fixed !important;\n  z-index: 1;\n  overflow: auto;\n  padding-top: 25px;\n}\n\n.Sidebars .row {\n  width: 100%;\n  display: block;\n  /* padding-top: 40px; */\n  text-align: center;\n  border: none;\n  white-space: normal;\n  float: none;\n  outline: 0;\n}\n\n.Sidebars .row svg {\n  color: white;\n  height: 100%;\n  width: 30px;\n}\n\n.Sidebars .notification svg {\n  color: white;\n  height: 100%;\n  width: 18px;\n}\n\n.Sidebars .notification {\n  width: 100%;\n  display: block;\n  /* padding-top: 50px; */\n  text-align: center;\n  border: none;\n  white-space: normal;\n  float: none;\n  outline: 0;\n}\n.completeRows {\n  display: flex;\n  flex-direction: column;\n  gap: 35px;\n  align-items: center;\n}\n.Sidebars .lowrow {\n  cursor: pointer;\n  padding: 13px;\n}\n.Sidebars .lowrow:hover {\n  background-color: crimson;\n}\n.Sidebars .lowrow svg {\n  color: white;\n  height: 100%;\n  width: 22px;\n}\n\n.circularBg {\n  background-color: #1976d2;\n  height: 45px;\n  width: 50px;\n  padding-left: 0px;\n  margin-left: 0px;\n}\n\n.notificationBg {\n  background-color: #1976d2;\n  height: 45px;\n  width: 50px;\n  padding-left: 0px;\n  margin-left: 0px;\n}\n.includingLogout {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
